export default __webpack_public_path__ + "static/media/Ballroll_00380.fa0e7e99.png";